import React from 'react';
import { motion } from 'framer-motion';
const features = [{
  emoji: '🍽️',
  title: 'Menu for Every Taste',
  desc: 'We provide a variety of meals served through various delicious menus.'
}, {
  emoji: '🌿',
  title: 'Fresh Organic Ingredients',
  desc: 'We use the freshest and most organic ingredients available to make our meals.'
}, {
  emoji: '👨‍🍳',
  title: 'Experienced Chefs',
  desc: 'Our chefs are highly experienced in the native preparation of the menus we serve.'
}];
export function WhyVictory() {
  return <section className="py-24 bg-charcoal text-white relative overflow-hidden" data-id="element-219">
      <div className="absolute inset-0 bg-cover bg-center opacity-10" style={{
      backgroundImage: 'url(https://i0.wp.com/victorykitchenz.com/wp-content/uploads/2022/06/egg-stew.jpg?fit=696%2C464&ssl=1)'
    }} data-id="element-220" />
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#D4A017 2px, transparent 2px)',
      backgroundSize: '30px 30px'
    }} data-id="element-221" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-222">
        <div className="text-center mb-20" data-id="element-223">
          <h2 className="font-heading text-4xl md:text-5xl uppercase tracking-wide mb-6" data-id="element-224">
            Why People <span className="text-amber" data-id="element-225">Choose Us</span>
          </h2>
          <div className="w-24 h-1 bg-victory-red mx-auto rounded-full" data-id="element-226" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-227">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.5
        }} className="flex flex-col items-center text-center group bg-white/5 backdrop-blur-sm p-8 rounded-3xl border border-white/10 hover:bg-white/10 transition-colors" data-id="element-228">
              <div className="text-6xl mb-6 group-hover:scale-110 transition-transform duration-300" data-id="element-229">
                {feature.emoji}
              </div>
              <h3 className="font-heading text-2xl uppercase tracking-wide mb-4 text-amber" data-id="element-230">
                {feature.title}
              </h3>
              <p className="font-body text-white/80 leading-relaxed text-lg" data-id="element-231">
                {feature.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}